if (!customElements.get('cards-grid')) {
  class CardsGrid extends HTMLElement {
    constructor() {
      super();

      this.grid = this.querySelector('[data-grid]');
      this.gridWrapper = this.grid.parentElement;
      this.showCardsPerScroll = 6;
    }

    connectedCallback() {
      this.initMasonry();
      this.handleIntersection();
    }

    initMasonry() {
      this.masonry = new Masonry(this.grid, {
        itemSelector: '[data-grid-item]',
        percentPosition: true,
      });
    }

    handleIntersection() {
      const options = {
        rootMargin: '-100% 0px 0px',
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          const isBelowContainer = entry.boundingClientRect.y <= 0;

          if (entry.isIntersecting || !isBelowContainer) return;

          const hiddenCards = this.grid.querySelectorAll(
            '[data-grid-item].is-hidden',
          );

          hiddenCards.forEach((card, index) => {
            if (index >= this.showCardsPerScroll) return;

            card.classList.remove('is-hidden');
          });

          if (hiddenCards.length > 0) this.masonry.layout();
        });
      }, options);

      observer.observe(this.gridWrapper);
    }
  }

  customElements.define('cards-grid', CardsGrid);
}
